import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import FormNumberField from "components/FormNumberField";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
/* eslint-disable react/prop-types */

const countryOptions = [
  { value: "Value 1", label: "Value 1" },
  { value: "Value 2", label: "Value 2" },
];

function Fields8({ formData }) {
  const { formField8, values, errors, touched } = formData;
  const {
    endow,
    departmentLevel,
    subordinateToTheDepartment,
    city,
    district,
    commune,
    isFemale,
    sumFemale,
    confirmFemale,
    dateConfirmFemale,
    isMinority,
    sumMinority,
    confirmMinority,
    dateConfirmMinority,
    taxReductionFemale,
    taxReductionMinority,
  } = formField8;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={endow.type}
            label={endow.label}
            name={endow.name}
            value={values.endow}
            placeholder={endow.placeholder}
            error={errors.endow && touched.endow}
            success={values.endow.length > 0 && !errors.endow}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={departmentLevel.type}
            label={departmentLevel.label}
            name={departmentLevel.name}
            value={values.departmentLevel}
            placeholder={departmentLevel.placeholder}
            error={errors.departmentLevel && touched.departmentLevel}
            success={values.departmentLevel.length > 0 && !errors.departmentLevel}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={subordinateToTheDepartment.type}
            label={subordinateToTheDepartment.label}
            name={subordinateToTheDepartment.name}
            value={values.subordinateToTheDepartment}
            placeholder={subordinateToTheDepartment.placeholder}
            error={errors.subordinateToTheDepartment && touched.subordinateToTheDepartment}
            success={
              values.subordinateToTheDepartment.length > 0 && !errors.subordinateToTheDepartment
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftBox ml={0.5} lineHeight={0} display="inline-block">
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              [09] Địa phuơng nơi có đơn vị phụ thuộc/ địa điểm kinh doanh có thu nhập được hưởng ưu
              đãi khác tỉnh nơi đóng trụ sở chính:
            </SoftTypography>
          </SoftBox>
        </Grid>

        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={city.type}
            label={city.label}
            name={city.name}
            value={values.city}
            placeholder={city.placeholder}
            error={errors.city && touched.city}
            success={values.city.length > 0 && !errors.city}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={district.type}
            label={district.label}
            name={district.name}
            value={values.district}
            placeholder={district.placeholder}
            error={errors.district && touched.district}
            success={values.district.length > 0 && !errors.district}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={commune.type}
            label={commune.label}
            name={commune.name}
            value={values.commune}
            placeholder={commune.placeholder}
            error={errors.commune && touched.commune}
            success={values.commune.length > 0 && !errors.commune}
          />
        </Grid>
        <Grid item xs={12} style={{ marginTop: 5 }}>
          <Typography variant="h4" textTransform="uppercase">
            A. Xác định điều kiện và mức độ ưu đãi thuế
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 2 }}>
          <Typography variant="h5">1. Điều kiện ưu đãi</Typography>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={isFemale.name} label={isFemale.label} value={values.isFemale} />
        </Grid>
        
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormNumberField
            name={sumFemale.name}
            label={sumFemale.label}
            value={values.sumFemale}
            error={errors.sumFemale && touched.sumFemale}
            success={values.sumFemale?.toString().length > 0 && !errors.sumFemale}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={confirmFemale.name}
            label={confirmFemale.label}
            value={values.confirmFemale}
            error={errors.confirmFemale && touched.confirmFemale}
            success={values.confirmFemale?.toString().length > 0 && !errors.confirmFemale}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            name={dateConfirmFemale.name}
            label={dateConfirmFemale.label}
            error={errors.dateConfirmFemale && touched.dateConfirmFemale}
            success={values.dateConfirmFemale?.toString().length > 0 && !errors.dateConfirmFemale}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={isMinority.name} label={isMinority.label} value={values.isMinority} />
        </Grid>
        
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormNumberField
            name={sumMinority.name}
            label={sumMinority.label}
            value={values.sumMinority}
            error={errors.sumMinority && touched.sumMinority}
            success={values.sumMinority?.toString().length > 0 && !errors.sumMinority}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={confirmMinority.name}
            label={confirmMinority.label}
            value={values.confirmMinority}
            error={errors.confirmMinority && touched.confirmMinority}
            success={values.confirmMinority?.toString().length > 0 && !errors.confirmMinority}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            name={dateConfirmMinority.name}
            label={dateConfirmMinority.label}
            error={errors.dateConfirmMinority && touched.dateConfirmMinority}
            success={values.dateConfirmMinority?.toString().length > 0 && !errors.dateConfirmMinority}
          />
        </Grid>
        <Grid item xs={12} style={{ marginTop: 2 }}>
          <Typography variant="h5">2. Mức độ ưu đãi thuế</Typography>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={taxReductionFemale.name} label={taxReductionFemale.label} value={values.taxReductionFemale} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={taxReductionMinority.name} label={taxReductionMinority.label} value={values.taxReductionMinority} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(Fields8);
